import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { enumNotiStatus, exchangedType } from "@configs";
import { ICoupon } from "@interfaces";
import { selectMerchant } from "@redux";
import { useSelector } from "react-redux";
import { CouponImage } from "../CouponImage";
import { DefaultCouponImage } from "../DefaultCouponImage";

interface IProps {
    data: ICoupon;
    onClick: () => void;
}

export const ComponentHistoryCoupon = (props: IProps) => {
    //page hooks
    const { t } = useTranslation();
    const { themes } = useSelector(selectMerchant);
    //page props
    const { data, onClick } = props;
    const date = dayjs(data.updatedAtHistory).format("DD MMM YYYY");
    const getStatusText = (status: enumNotiStatus) => {
        switch (status) {
            case enumNotiStatus.PENDING:
                return "Pending";
                break;
            case enumNotiStatus.RESOLVED:
                return "Use";
                break;
            case enumNotiStatus.REJECT:
                return "Cancel";
                break;
            default:
                return "Pending";
                break;
        }
    };
    const isActive = () => data?.notiStatus === enumNotiStatus.PENDING;
    return (
        <StyledContainerCoupon
            onClick={onClick}
            isRECEIVED={data.exchangedType === exchangedType.RECEIVED}
        >
            <div className="img-layout">
                {data?.imageUrl.length === 0 ? (
                    <DefaultCouponImage color={isActive() ? themes?.themeColor : "#E1E1E1"} />
                ) : (
                    <>
                        <CouponImage imageUrl={data?.imageUrl[0]} />
                        <div className={isActive() ? "" : "used"} />
                    </>
                )}
                <div className={isActive() ? "status active" : "status"}>
                    <span> {isActive() ? t("page.active") : t("page.used")}</span>
                </div>
            </div>
            <div className="body">
                <div>
                    <div className="type">{t("page.coupon")}</div>
                    <div className="title text-sub-header">{data?.name}</div>
                </div>
                <div className="date">
                    <span className="status text-small">
                        {data.exchangedType === exchangedType.RECEIVED
                            ? t("page.collected")
                            : t("page.used")}
                    </span>
                    <span className="time text-small eng">{date}</span>
                </div>
            </div>
            <div className="quality">
                <p>{data.exchangedType === exchangedType.RECEIVED ? "+1" : "-1"}</p>
                <StyledUsedBtn themeColor={themes?.themeColor!}>
                    {getStatusText(data?.notiStatus)}
                </StyledUsedBtn>
            </div>
        </StyledContainerCoupon>
    );
};
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: #ffffff;
    }
`;
const StyledContainerCoupon = styled.div<{ isRECEIVED: boolean }>`
    display: flex;
    justify-content: space-between;
    background: ${(p) => p.theme.colors.card};
    cursor: pointer;
    border-radius: 14px;
    margin-bottom: 10px;
    p {
        margin: 0;
    }
    .img-layout {
        flex: 1;
        position: relative;
        .status {
            padding: 4px 8px;
            background: #676767;
            border-radius: 4px;
            position: absolute;
            top: 3px;
            left: -9px;
            z-index: 1;
            color: #fff;
            &.active {
                background: #49c549;
            }
            span {
                font-weight: 500;
                font-size: 10px;
                color: #fff;
                line-height: 16px;
                text-align: right;
                /* background: ${(p) => p.theme.colors.card}; */
                background: transparent;
            }
        }
        .used {
            width: 100%;
            padding-top: 90px;
            position: absolute;
            top: 0;
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
            background: ${(p) => p.theme.colors.card};
            opacity: 0.4;
        }
    }
    .body {
        flex: 2;
        padding: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .type {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #676767;
        }
        .title {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 19px;
            color: ${(p) => p.theme.colors.color};
        }
        .date {
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 14px;
            color: #919191;
        }
    }
    .quality {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: end;
        padding: 12px;
        justify-content: space-between;
        p {
            margin: 0;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            text-align: right;
            color: ${(p) => (p.isRECEIVED ? "#378A00" : "#970000")};
        }
    }
`;
